// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__rxjW6","table":"Table_table__3F9ql","btn":"Table_btn__mP03D"};